import { LuminousGallery } from "luminous-lightbox";

const galleryNodes = document.querySelectorAll(".Gallery__item--lightbox");
if (galleryNodes) {
  new LuminousGallery(galleryNodes);
}
